:host {
  display: inline;
}

.price {
  font-family: var(--primary-font);
  font-weight: var(--font-weight-semibold);
  line-height: 20px;
  display: block;
  height: 15px;

  @include breakpointMin('sm') {
    display: inline-block;
  }

  &.normal {
    color: var(--color-nero);
  }

  &.hit {
    color: var(--color-livique-cherryade);
  }

  &.sale {
    position: relative;
    color: var(--color-silver);
    font-weight: 400;
  }

  &.big {
    font-size: 18px;
    line-height: 20px;
  }

  &.sale:before {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    right: 0;
    width: 100%;
    border-top: 1px solid;
    border-color: #c1003c;
    transform: rotate(-4deg);
  }

  &.size-sm {
    font-size: 10px;

    @include breakpointMin('lg') {
      font-size: 16px;
    }
  }

  &.size-md {
    font-size: 12px;

    @include breakpointMin('lg') {
      font-size: 16px;
    }
  }

  &.size-lg {
    font-size: 18px;
  }

  &.size-xl {
    font-size: 18px;

    @include breakpointMin('lg') {
      font-size: 20px;
    }
  }
}